import type { FC } from 'react';

import { StateView } from '@/shared/components/state-view/StateView';

export const EmptyScreen: FC = () => <StateView isEmpty />;
